import Vue from 'vue'
import App from './App.vue'
//import axios from 'axios'
import axios from '@/modules/http';
import VueAxios from 'vue-axios'

import VueLocalStorage from 'vue-localstorage'
import router from '@/router'
import store from '@/store'
import filterError from '@/filters/error'
import names from '@/filters/names'
import userLogin from '@/plugins/UserLogin'
import AppCallApi from '@/plugins/AppCallApi'

import VueDraggable from 'vue-draggable'

import Chart from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'


Chart.plugins.unregister(ChartDataLabels) 
Chart.plugins.register(ChartDataLabels);

//

Vue.config.productionTip = false

import '@/assets/css/bootstrap.min.css'
import '@/assets/css/icons.min.css'
import '@/assets/css/app.min.css'
import '@/assets/css/main.css'

const filters = [...filterError, ...names]

filters.forEach(f => {
  Vue.filter(f.name, f.execute)
})

Vue.use(VueAxios, axios)
//Vue.prototype.$axios = axios; 
Vue.use(VueLocalStorage, {
  name: 'ls',
  bind: true
});

Vue.use(userLogin, store)
Vue.use(AppCallApi, axios)

Vue.use(VueDraggable)
Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
